import React from 'react';
import PropTypes from 'prop-types';

import { translate } from '../i18n/localize';

function DangerString(props) {
  const { className, placeholders, stringKey } = props;

  return (
    <span className={className} dangerouslySetInnerHTML={{
      __html: translate(stringKey, placeholders)
    }} />
  );
}

DangerString.propTypes = {
  className: PropTypes.string,
  placeholders: PropTypes.object,
  stringKey: PropTypes.string.isRequired,
};

export default DangerString;
